import React from "react"

import dayjs from "../../shared/helpers/dayjs";

import Select from "./Select"

const Rounds = props => {
  const _isTimeBand = id =>
    props.teeTimes.some(time => time.id === id && time.band)

  const _formatTime = time => `${time.substr(0, 2)}:${time.substr(2)}`

  const offerHasTimeBandSelected =
    Object.values(props.selectedTimes).some(_isTimeBand)

  const dateHasTimeBand = date => _isTimeBand(props.selectedTimes[date])

  const handleCourseSelect = date => e => {
    props.handleCourseSelect(e.target.value, date)
  }

  const handleTimeSelect = date => e => {
    props.handleTimeSelect(e.target.value, date)
  }

  const formatTimeOrBand = teeTime => {
    return teeTime.band
      ? teeTime.band.split("-").map(_formatTime).join("-")
      : _formatTime(teeTime.time);
  };

  const courseOptions = date => {
    const selectedCourse = props.selectedCourses[date]
    const options = props.coursesByDate[date]
      .map(course => ({ value: course, text: course }))

    return {
      options,
      selected: { value: selectedCourse, text: selectedCourse },
      handleSelect: handleCourseSelect(date)
    }
  }

  const timeOptions = date => {
    const times = props.teeTimes
    const selectedCourse = props.selectedCourses[date]
    const selectedTimeId = props.selectedTimes[date]
    const formattedTime = formatTimeOrBand(
      times.find(time => time.id === selectedTimeId)
    )
    const options = props
      .timesForDateAndCourse(times, date, selectedCourse)
      .map(time => ({ value: time.id, text: formatTimeOrBand(time) }))

    return {
      options,
      selected: { value: selectedTimeId, text: formattedTime },
      handleSelect: handleTimeSelect(date)
    }
  }

  return (
    <div>
      {Object.keys(props.coursesByDate)
        .sort()
        .map(date => (
          <div key={date} className="callout callout--primary">
            1 round at <Select {...courseOptions(date)} />
            <span> on </span> {dayjs(date).format("dddd")}
            {dateHasTimeBand(date)
              ? <span> teeing off between <Select {...timeOptions(date)} />*</span>
              : <span> teeing off at <Select {...timeOptions(date)} /></span>
            }
          </div>
        ))
      }

      {offerHasTimeBandSelected &&
        <small>
          * You are booking a tee time within the selected timeband, upon
          payment you will receive an automatic confirmation of your request.
          Our Customer Services Team will then finalise your booking and
          contact you as soon as possible to confirm the actual tee time
          allocated.
        </small>
      }
    </div>
  )
}

export default Rounds



// WEBPACK FOOTER //
// ./components/last_minute_deals/Rounds.jsx